import _ from 'lodash'
import {MediaObject} from '@/modules/media/types'
import KeyValuePair from '@/modules/core/support/KeyValuePair'

/**
 * Elemento de una galería
 *
 * @author Alejandro G. Riaño <agutierrez@softcontrol.es>
 */
export default class GalleryItem {
    public readonly tempId = _.uniqueId('gallery_id_')
    public link = ''
    public duration = 500
    public active = false

    /**
     * Constructor
     * @param id
     * @param media
     */
    constructor (public readonly id = 0, public media = new MediaObject()) {}

    /**
     * Convierte la información plana en una entidad
     *
     * @param data
     */
    public static deserialize (data: KeyValuePair) {
        const item = new this(data.id)
        item.active = data.active
        item.duration = data.duration
        item.link = data.link
        item.media = MediaObject.convert(data.media)

        return item
    }

    /**
     * Convierte la entidad a información plana para ser enviada
     */
    public serialize () {
        return {
            id: this.id,
            active: this.active,
            duration: this.duration,
            media: this.media.id,
            link: this.link,
        }
    }
}
